
// import { useState, useEffect } from "react";
// import Header from "../component/Header";
// import { Chart as ChartJS, ArcElement, BarElement, Tooltip, Legend } from 'chart.js';
// import { Pie, Bar } from 'react-chartjs-2';
// import axios from "axios";
// import UserProfile from "./others/UserProfile";
// import ServiceHistory from "./others/ServiceHistory";

// import SearchPosts from "./sidebarItems/SearchForPosts";
// import PostForm from "./sidebarItems/CreateAPost";
// import ApplicationsList from "./sidebarItems/ApplicationList";
// import ClientSearchProviders from "./sidebarItems/ClientSearchProvider";
// import ProviderProfileUpdate from "./sidebarItems/ProviderUpdateForm";
// import ClientRequestsDashboard from "./sidebarItems/ClientRequestsDashboard";
// import OoshDashboard from "./sidebarItems/OOshDashboard";
// import Notifications from "./sidebarItems/Notification";

// ChartJS.register(ArcElement, BarElement, Tooltip, Legend);

// // Dashboard component to be used as the default content
// const DashboardContent = () => {
//   const [showPin, setShowPin] = useState(false);
//   const email = localStorage.getItem('ooshEmail') || '';
//   const pin = localStorage.getItem('ooshPin') || '';
//   const uniqueNumber = localStorage.getItem('ooshUniqueNumber') || '';
//    const [profile, setProfile] = useState(null);

//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}oosh/profile`, {
//           params: { email },
//         });
//         if (response.data.success) {
//           localStorage.setItem('userProfile', JSON.stringify(response.data.profile));
//           setProfile(response.data.profile);
//         }
//       } catch (error) {
//         console.error('Error fetching profile:', error);
//       }
//     };
//     if (email) fetchProfile();
//   }, [email]);

//   const patronageData = {
//     labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     datasets: [
//       {
//         label: 'Patronage Breakdown',
//         data: [20, 40, 60, 80, 100, 80, 60, 40, 20, 30, 50, 70],
//         backgroundColor: 'rgba(59, 130, 246, 0.2)',
//         borderColor: 'rgba(59, 130, 246, 1)',
//         borderWidth: 1,
//       },
//     ],
//   };

//   const weeklyEngagementData = {
//     labels: ['Likes', 'Views', 'Shares', 'Reviews'],
//     datasets: [
//       {
//         data: [25, 20, 10, 45],
//         backgroundColor: ['#10B981', '#3B82F6', '#9333EA', '#EF4444'],
//         borderWidth: 0,
//       },
//     ],
//   };

//   const targetData = {
//     labels: ['Target Reached', 'Remaining'],
//     datasets: [
//       {
//         data: [50, 50],
//         backgroundColor: ['#8B5CF6', '#D1D5DB'],
//         borderWidth: 0,
//       },
//     ],
//   };

//   const audienceData = {
//     labels: ['Target Audience', 'Regular Audience'],
//     datasets: [
//       {
//         data: [70, 30],
//         backgroundColor: ['#3B82F6', '#D1D5DB'],
//         borderWidth: 0,
//       },
//     ],
//   };

//   return (
//     <div className="bg-white p-4 rounded-lg shadow border-4 border-blue-200">
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-xl font-bold text-blue-600">OOSH Dashboard</h2>
//         <div className="relative">
//           <span className="text-lg font-semibold">
//             PIN: {showPin ? pin : '*****'} ({uniqueNumber})
//           </span>
//           <button
//             onClick={() => setShowPin(!showPin)}
//             className="ml-2 text-gray-500"
//           >
//             {showPin ? '🙈' : '👁️'}
//           </button>
//         </div>
//       </div>
//       <div className="grid grid-cols-2 gap-4 mb-4">
//         <div className="p-4 bg-gray-50 rounded">
//           <p>Total Posted: 10,680 <span className="text-red-500">(-12.7% than last month)</span></p>
//         </div>
//         <div className="p-4 bg-gray-50 rounded">
//           <p>Total Applied: 40,100 <span className="text-green-500">(+34% than last month)</span></p>
//         </div>
//       </div>
//       <div className="grid grid-cols-2 gap-4 mb-4">
//         <div className="p-4 bg-gray-50 rounded">
//           <p>Total Engagement: 10,680 <span className="text-red-500">(-12.7% than last month)</span></p>
//           <p>$3,06.80</p>
//         </div>
//         <div className="p-4 bg-gray-50 rounded">
//           <Bar data={patronageData} />
//         </div>
//       </div>
//       <div className="grid grid-cols-3 gap-4">
//         <div className="p-4 bg-gray-50 rounded">
//           <div className="h-32 flex items-center justify-center">
//             <Pie data={weeklyEngagementData} />
//           </div>
//           <p className="text-center mt-2">Weekly Engagement Performance</p>
//         </div>
//         <div className="p-4 bg-gray-50 rounded">
//           <div className="h-32 flex items-center justify-center">
//             <Pie data={targetData} />
//           </div>
//           <p className="text-center mt-2">Target</p>
//         </div>
//         <div className="p-4 bg-gray-50 rounded">
//           <div className="h-32 flex items-center justify-center">
//             <Pie data={audienceData} />
//           </div>
//           <p className="text-center mt-2">Audience</p>
//         </div>
//       </div>
//        {profile && (
//         <div className="mt-4 p-4 bg-gray-50 rounded">
//           <h3 className="text-lg font-semibold">Profile</h3>
//           <p>Name:  {profile.companyName || profile.firstName  || 'Not available'} {profile.lastName  || ''} </p>
//           <p>User Type: {profile.userType || 'Not available'}</p>
//           {/* Add other profile fields as needed */}
//         </div>
//       )}
//     </div>
//   );
// };

// const Dashboard = () => {
//   const [activeTab, setActiveTab] = useState('dashboard');
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);
//   const [activeServiceTab, setActiveServiceTab] = useState(null);

//   const sidebarItems = [
//     { id: 'dashboard', label: 'Dashboard', component: DashboardContent },
  
//     { id: 'serviceHistory', label: 'History', component: ServiceHistory },
//     { id: 'searchPosts', label: 'Search For Posts', component: SearchPosts },
//     { id: 'postForm', label: 'post what you need', component: PostForm },
//     // { id: 'applicationList', label: 'Form Application', component: ApplicationsList },
//     { id: 'searchservices', label: 'search for services', component:ClientSearchProviders },
//     { id: 'updateprofile', label: 'Update your profile', component:ProviderProfileUpdate },
//     { id: 'clientrequest', label: 'clientrequest', component:ClientRequestsDashboard },
//     { id: 'data', label: 'Data', component:OoshDashboard },
//     { id: 'notification', label: 'Notification', component:Notifications },
//   ];

//   // Determine the active component based on the main tab or service dropdown
//   const getActiveComponent = () => {
//     const mainItem = sidebarItems.find(item => item.id === activeTab);
//     if (mainItem && mainItem.dropdown && activeServiceTab) {
//       const subItem = mainItem.dropdown.find(sub => sub.id === activeServiceTab);
//       return subItem ? subItem.component : () => <div>No Content Available</div>;
//     }
//     return mainItem ? mainItem.component : () => <div>No Content Available</div>;
//   };

//   const ActiveComponent = getActiveComponent();

//   return (
//     <div className="flex h-screen bg-gray-100">
//       {/* Sidebar */}
//       <div
//         className={`fixed inset-y-0 left-0 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:relative md:translate-x-0 w-64 bg-white shadow-lg transition duration-200 ease-in-out z-20`}
//       >
//         <div className="p-4 mt-20">
//           <nav>
//             {sidebarItems.map((item) => (
//               <div key={item.id}>
//                 {item.dropdown ? (
//                   <div>
//                     <button
//                       onClick={() => {
//                         setServiceDropdownOpen(!serviceDropdownOpen);
//                         if (!serviceDropdownOpen) setActiveServiceTab(null); // Reset sub-tab when closing
//                       }}
//                       className={`w-full text-left p-2 my-1 rounded hover:bg-blue-100 ${activeTab === item.id ? 'bg-blue-200' : ''}`}
//                     >
//                       {item.label} {serviceDropdownOpen ? '▲' : '▼'}
//                     </button>
//                     {serviceDropdownOpen && (
//                       <div className="pl-4">
//                         {item.dropdown.map((subItem) => (
//                           <button
//                             key={subItem.id}
//                             onClick={() => {
//                               setActiveTab(item.id);
//                               setActiveServiceTab(subItem.id);
//                             }}
//                             className={`w-full text-left p-2 my-1 rounded hover:bg-blue-100 ${activeServiceTab === subItem.id ? 'bg-blue-100' : ''}`}
//                           >
//                             {subItem.label}
//                           </button>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 ) : (
//                   <button
//                     key={item.id}
//                     onClick={() => {
//                       setActiveTab(item.id);
//                       setActiveServiceTab(null);
//                       setServiceDropdownOpen(false);
//                     }}
//                     className={`w-full text-left p-2 my-1 rounded hover:bg-blue-100 ${activeTab === item.id ? 'bg-blue-200' : ''}`}
//                   >
//                     {item.label}
//                   </button>
//                 )}
//               </div>
//             ))}
//           </nav>
//         </div>
//       </div>

//       {/* Hamburger Menu Button for Mobile */}
//       <button
//         className="md:hidden p-4 text-blue-600 focus:outline-none z-30 fixed top-10 left-4"
//         onClick={() => setIsSidebarOpen(!isSidebarOpen)}
//       >
//         <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
//         </svg>
//       </button>

//       {/* Main Content */}
//       <div className="flex-1 p-6 pt-20 overflow-auto">
//         <Header />
//         <div className="mt-6">
//           <ActiveComponent />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;



import { useState, useEffect } from "react";
import Header from "../component/Header";
import { Chart as ChartJS, ArcElement, BarElement, Tooltip, Legend } from 'chart.js';
import { Pie, Bar } from 'react-chartjs-2';
import axios from "axios";


import SearchPosts from "./sidebarItems/SearchForPosts";
import PostForm from "./sidebarItems/CreateAPost";
import ApplicationsList from "./sidebarItems/ApplicationList";
import ClientSearchProviders from "./sidebarItems/ClientSearchProvider";
import ProviderProfileUpdate from "./sidebarItems/ProviderUpdateForm";
import ClientRequestsDashboard from "./sidebarItems/ClientRequestsDashboard";
import OoshDashboard from "./sidebarItems/OOshDashboard";
import Notifications from "./sidebarItems/Notification";

ChartJS.register(ArcElement, BarElement, Tooltip, Legend);

// Dashboard component to be used as the default content
const DashboardContent = () => {
  const [notifications, setNotifications] = useState([]);
  const [showPin, setShowPin] = useState(false);
  const email = localStorage.getItem('ooshEmail') || '';
  const pin = localStorage.getItem('ooshPin') || '';
  const uniqueNumber = localStorage.getItem('ooshUniqueNumber') || '';
  const [profile, setProfile] = useState(null);
  const [stats, setStats] = useState({
    totalUsers: 0,
    jobEmployers: 0,
    jobSeekers: 0,
    suppliers: 0,
    contractors: 0,
    serviceProviders: 0,
    userRequests: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/profile`, {
          params: { email },
        });
        if (response.data.success) {
          localStorage.setItem('userProfile', JSON.stringify(response.data.profile));
          setProfile(response.data.profile);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };
    if (email) fetchProfile();
  }, [email]);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/stats`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setStats(res.data);
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
      setLoading(false);
    };
    fetchStats();
  }, []);



   const fetchNotifications = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/notifications`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setNotifications(res.data);
      } catch (err) {
        console.error('Error fetching notifications:', err);
      }
    };
  
    const handleMarkRead = async (id) => {
      try {
        await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/notifications/${id}/read`, {}, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        fetchNotifications(); // Refresh list
      } catch (err) {
        console.error('Error marking as read:', err);
      }
    };
   const unreadCount = notifications.filter((n) => !n.read).length;

  const userTypesData = {
    labels: ['Job Employers', 'Job Seekers'],
    datasets: [{
      data: [stats.jobEmployers, stats.jobSeekers],
      backgroundColor: ['#3B82F6', '#10B981'],
      borderWidth: 0,
    }],
  };

  const rolesData = {
    labels: ['Suppliers', 'Contractors', 'Service Providers'],
    datasets: [{
      data: [stats.suppliers, stats.contractors, stats.serviceProviders],
      backgroundColor: ['#9333EA', '#F59E0B', '#EC4899'],
      borderWidth: 0,
    }],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow border-4 border-blue-200">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-blue-600">OOSH Dashboard</h2>
        <div className="relative">
          <span className="text-lg font-semibold">
            PIN: {showPin ? pin : '*****'} ({uniqueNumber})
          </span>
          <button
            onClick={() => setShowPin(!showPin)}
            className="ml-2 text-gray-500"
          >
            {showPin ? '🙈' : '👁️'}
          </button>
        </div>
      </div>
      {loading ? (
        <p className="text-center text-gray-500">Loading data...</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <div className="p-4 bg-gray-50 rounded text-center">
            <p className="text-lg font-bold">Total Oosh Users</p>
            <p className="text-2xl">{stats.totalUsers}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded text-center">
            <p className="text-lg font-bold">My Requests</p>
            <p className="text-2xl">{stats.userRequests}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded text-center">
            <p className="text-lg font-bold">Job Employers</p>
            <p className="text-2xl">{stats.jobEmployers}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded text-center">
            <p className="text-lg font-bold">Job Seekers</p>
            <p className="text-2xl">{stats.jobSeekers}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded text-center">
            <p className="text-lg font-bold">Suppliers</p>
            <p className="text-2xl">{stats.suppliers}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded text-center">
            <p className="text-lg font-bold">Contractors</p>
            <p className="text-2xl">{stats.contractors}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded text-center">
            <p className="text-lg font-bold">Service Providers</p>
            <p className="text-2xl">{stats.serviceProviders}</p>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <div className="p-4 bg-gray-50 rounded">
          <h3 className="text-center text-lg font-bold mb-2">User Types Breakdown</h3>
          <div className="h-48 w-full">
            <Pie data={userTypesData} options={chartOptions} />
          </div>
        </div>
        <div className="p-4 bg-gray-50 rounded">
          <h3 className="text-center text-lg font-bold mb-2">Roles Breakdown</h3>
          <div className="h-48 w-full">
            <Pie data={rolesData} options={chartOptions} />
          </div>
        </div>
      </div>
      {profile && (
        <div className="mt-4 p-4 bg-gray-50 rounded">
          <h3 className="text-lg font-semibold">Profile</h3>
          <p>Name: {profile.companyName || profile.firstName || 'Not available'} {profile.lastName || ''}</p>
          <p>User Type: {profile.userType || 'Not available'}</p>
          {/* Add other profile fields as needed */}
        </div>
      )}
    </div>
  );
};

// Rest of the Dashboard componentremains unchanged

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);
  const [activeServiceTab, setActiveServiceTab] = useState(null);

  const sidebarItems = [
    { id: 'dashboard', label: 'Dashboard', component: DashboardContent },

    { id: 'searchPosts', label: 'Search For Posts', component: SearchPosts },
    { id: 'postForm', label: 'post what you need', component: PostForm },
    // { id: 'applicationList', label: 'Form Application', component: ApplicationsList },
    { id: 'searchservices', label: 'search for services', component:ClientSearchProviders },
    { id: 'updateprofile', label: 'Update your profile', component:ProviderProfileUpdate },
    { id: 'clientrequest', label: 'clientrequest', component:ClientRequestsDashboard },
    { id: 'data', label: 'Data', component:OoshDashboard },
    { id: 'notification', label: 'Notification', component:Notifications },
  ];

  // Determine the active component based on the main tab or service dropdown
  const getActiveComponent = () => {
    const mainItem = sidebarItems.find(item => item.id === activeTab);
    if (mainItem && mainItem.dropdown && activeServiceTab) {
      const subItem = mainItem.dropdown.find(sub => sub.id === activeServiceTab);
      return subItem ? subItem.component : () => <div>No Content Available</div>;
    }
    return mainItem ? mainItem.component : () => <div>No Content Available</div>;
  };

  const ActiveComponent = getActiveComponent();

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:relative md:translate-x-0 w-64 bg-white shadow-lg transition duration-200 ease-in-out z-20`}
      >
        <div className="p-4 mt-20">
          <nav>
            {sidebarItems.map((item) => (
              <div key={item.id}>
                {item.dropdown ? (
                  <div>
                    <button
                      onClick={() => {
                        setServiceDropdownOpen(!serviceDropdownOpen);
                        if (!serviceDropdownOpen) setActiveServiceTab(null); // Reset sub-tab when closing
                      }}
                      className={`w-full text-left p-2 my-1 rounded hover:bg-blue-100 ${activeTab === item.id ? 'bg-blue-200' : ''}`}
                    >
                      {item.label} {serviceDropdownOpen ? '▲' : '▼'}
                    </button>
                    {serviceDropdownOpen && (
                      <div className="pl-4">
                        {item.dropdown.map((subItem) => (
                          <button
                            key={subItem.id}
                            onClick={() => {
                              setActiveTab(item.id);
                              setActiveServiceTab(subItem.id);
                            }}
                            className={`w-full text-left p-2 my-1 rounded hover:bg-blue-100 ${activeServiceTab === subItem.id ? 'bg-blue-100' : ''}`}
                          >
                            {subItem.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <button
                    key={item.id}
                    onClick={() => {
                      setActiveTab(item.id);
                      setActiveServiceTab(null);
                      setServiceDropdownOpen(false);
                    }}
                    className={`w-full text-left p-2 my-1 rounded hover:bg-blue-100 ${activeTab === item.id ? 'bg-blue-200' : ''}`}
                  >
                    {item.label}
                  </button>
                )}
              </div>
            ))}
          </nav>
        </div>
      </div>

      {/* Hamburger Menu Button for Mobile */}
      <button
        className="md:hidden p-4 text-blue-600 focus:outline-none z-30 fixed top-10 left-4"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
      </button>

      {/* Main Content */}
      <div className="flex-1 p-6 pt-20 overflow-auto">
        <Header />
        <div className="mt-6">
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;